import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconConditionForecast = ({ width = 60, height = 30, viewBox = '0 0 60 30', color = colors.primaryPurple }) => {
    return (
        <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect x='0' y='0' width='60' height='30' fill={colors.primaryPurpleBackground} />
            <line
                x1='3' y1='15' x2='57' y2='15'
                stroke={color}
                strokeWidth='3'
                strokeLinecap='round'
                strokeDasharray='6 5'
            />
        </svg>
    );
};

IconConditionForecast.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconConditionForecast;
